export const saveSetting = ({ commit }, payload) => commit('saveSetting', payload)
export const saveSettingSession = ({ commit }, payload) => commit('saveSettingSession', payload)
export const deleteSetting = ({ commit }, payload) => commit('deleteSetting', payload)
export const login = ({ commit }, payload) => commit('login', payload)
export const logout = ({ commit }) => commit('logout')

export const setOptions = ({ commit }, payload) => commit('setOptions', payload)
export const setOptionsLoaded = ({ commit }, payload) => commit('setOptionsLoaded', payload)
export const setProjects = ({ commit }, payload) => commit('setProjects', payload)
export const addProject = ({ commit }, payload) => commit('addProject', payload)
export const editProject = ({ commit }, payload) => commit('editProject', payload)
export const removeProject = ({ commit }, payload) => commit('removeProject', payload)
export const addIndex = ({ commit }, payload) => commit('addIndex', payload)
export const removeIndex = ({ commit }, payload) => commit('removeIndex', payload)
export const setIndexes = ({ commit }, payload) => commit('setIndexes', payload)
export const setProjectsFile = ({ commit }, payload) => commit('setProjectsFile', payload)

export const setProp = ({ commit }, payload) => commit('setProp', payload)

export const flushData = ({ commit }) => commit('flushData')

export const addComment = ({ commit }, payload) => commit('addComment', payload)



// WEBPACK FOOTER //
// ./src/store/actions.js